import React from "react"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Helmet } from "react-helmet"
import { useGetPagesDataQuery } from "redux/cms/api"
import CmsTab from "../Common/Tab"
function Shopping() {
  const { data, isLoading, isSuccess, refetch } =
    useGetPagesDataQuery("shopping")

  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "Shopping",
      link: "/pages/shopping",
    },
    paths: [
      {
        label: "Pages",
        link: "/pages/shopping",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Shopping | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <CmsTab
            data={data}
            isLoading={isLoading}
            isSuccess={isSuccess}
            tab={"Shopping"}
            refetch={refetch}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Shopping
